module.exports = __webpack_public_path__ + "static/img/gifits.ee7c818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifits.png
// module id = 7pPE
// module chunks = 31